import React from "react";

const PieChart = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M15.422 4.247v16.33h16.33C31.006 28.115 24.647 34 16.915 34 8.676 34 2 27.323 2 19.087c0-7.733 5.886-14.092 13.422-14.84zM18.405 2C26.686 2.711 33.287 9.314 34 17.595H18.405V2z"
            fill={fill}
        />
    </svg>
);

export default PieChart;
